package pl.finn.forms.teryt

import kotlinx.serialization.Serializable

@Serializable
data class AddressList(
  var addresses: ArrayList<Address> = arrayListOf<Address>()
)

@Serializable
data class Address(
  val post_code: String? = null,
  val level: String? = null,
  val gus_name: String? = null,
  val locality: String? = null,
  val street: String? = null,
  val office: String? = null,
  val gus: String? = null
)

@Serializable
data class VoivodeshipList(
  var voivodeships: ArrayList<Voivodeship> = arrayListOf<Voivodeship>()
)

@Serializable
data class Voivodeship(
  val sym_w: String? = null,
  val name: String? = null
)

@Serializable
data class CountyList(
  var countries: ArrayList<Country> = arrayListOf<Country>()
)

@Serializable
data class Country(
  val sym_p: String? = null,
  val name: String? = null

)

@Serializable
data class CommunityList(
  var communities: ArrayList<Community> = arrayListOf<Community>()
)

@Serializable
data class Community(
  val symcommunity: String? = null,
  val name: String? = null,
  val communitytype: String? = null

)

@Serializable
data class LocalityList(
  var localities: ArrayList<Locality> = arrayListOf<Locality>()
)

@Serializable
data class Locality(
  val symlocality: String? = null,
  val name: String? = null,
  val localitytype: String? = null

)

@Serializable
data class StreetList(
  var streets: ArrayList<Street> = arrayListOf<Street>()
)
@Serializable
data class Street(
  val name: String? = null,
  val sym_ul: String? = null,
  val streettype: String? = null
)
